import { forwardRef, type Ref, type SVGProps } from "react";
const IconChevronRightFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.587 2.592a2 2 0 0 0 0 2.83l10.58 10.58-10.58 10.58a2.001 2.001 0 1 0 2.83 2.83l12-12a2 2 0 0 0 0-2.83l-12-12a2 2 0 0 0-2.83.01"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconChevronRightFilledSVG);
ForwardRef.displayName = "IconChevronRightFilled";
export { ForwardRef as IconChevronRightFilled };
